export function EditLinear({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span className={`icon ${className}`}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 18 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.94452 3.20041L3.78702 9.71791C3.55452 9.96541 3.32952 10.4529 3.28452 10.7904L3.00702 13.2204C2.90952 14.0979 3.53952 14.6979 4.40952 14.5479L6.82452 14.1354C7.16202 14.0754 7.63452 13.8279 7.86702 13.5729L14.0245 7.05541C15.0895 5.93041 15.5695 4.64791 13.912 3.08041C12.262 1.52791 11.0095 2.07541 9.94452 3.20041Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.91797 4.28711C9.24047 6.35711 10.9205 7.93961 13.0055 8.14961"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.25 17H15.75"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
}
